import en from './systemMessages/en';
import sv from './systemMessages/sv';

const locales = { en, sv };

type Locale = 'en' | 'sv';
type SystemMessages = typeof en;
type SystemMessageId = keyof SystemMessages;

function getStoredLocale(): Locale {
    const stored = localStorage.getItem('locale');
    return stored === 'sv' ? 'sv' : 'en';
}

export function formatSystemMessage(
    id: SystemMessageId,
    defaultMessage?: string,
): string {
    const locale = getStoredLocale();
    const messages = locales[locale] ?? en;

    return messages[id] || defaultMessage || id;
}
